import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { AppService } from "src/app/core/services/app.service";
import { QuoteViewerService } from "src/app/core/services/quote-viewer.service";
import { QuoteAcceptance, QuoteLineItemRecord } from "src/app/shared/models/DTO/quote-viewer.dto";

@Component({
	selector: "app-quote-accept-and-order",
	templateUrl: "./quote-accept-and-order.component.html",
	styleUrls: ["./../quote-viewer.scss"],
})
export class QuoteAcceptAndOrderComponent implements OnInit {
	hasGift: boolean = false;
	hasFocusProducts: boolean = false;
	hasProfessionalServices: boolean = false;

	quoteAcceptance: QuoteAcceptance = new QuoteAcceptance();

	constructor(public app: AppService, public quoteService: QuoteViewerService, private router: Router) {}

	ngOnInit(): void {
		this.quoteService.quote.subscribe((data) => {
			if (data?.Id) {
				this.evaluateItems(data.QuoteLineItems.records);
				this.quoteAcceptance.quoteId = data.Id;
				this.quoteAcceptance.opportunityId = data.Opportunity.Id;
				this.quoteAcceptance.accountId = data.Opportunity.Account.Id;
			}
		});
	}

	evaluateItems(items: QuoteLineItemRecord[]) {
		items.forEach((item) => {
			if (item.Item_Description__c?.toLowerCase().includes("license")) {
				this.hasFocusProducts = true;
			}
			if (item.Item_Description__c?.toLowerCase().includes("focuscloud license") || item.Item_Description__c.toLowerCase().includes("gift")) {
				this.hasGift = true;
			}

			if (item.Product2.Family === "Professional Services") {
				this.hasProfessionalServices = true;
			}
		});
	}

	async submitOrder() {
		const pdfBlob = await this.generatePdf();
		await this.quoteService.submitOrder(this.quoteAcceptance, pdfBlob);

		this.router.navigate([`quote/${this.quoteService.quote.value.Id}/complete`]);
	}

	async generatePdf() {
		var data = document.getElementById("focusQuote");
		const defaultShadowStyle = window.getComputedStyle(data).boxShadow;
		setShadowStyle(data, "none");
		const canvas = await html2canvas(data, {
			scale: 2,
		});

		const imgData = canvas.toDataURL("image/png");
		var imgWidth = 208;
		var pageHeight = 298;
		var imgHeight = (canvas.height * imgWidth) / canvas.width;
		var heightLeft = imgHeight;

		var doc = new jsPDF("p", "mm", "a4", true);
		var position = 0;
		doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
		heightLeft -= pageHeight;

		while (heightLeft >= 0) {
			position = heightLeft - imgHeight;
			doc.addPage();
			doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;
		}

		const binary = doc.output();
		setShadowStyle(data, defaultShadowStyle);

		return binary ? btoa(binary) : "";

		// A function that assigns a shadow style to an element
		function setShadowStyle(el, shadowStyle) {
			el.style.boxShadow = shadowStyle;
		}
	}
}
